module.exports = __webpack_public_path__ + "static/img/logo_v2.f7b170d9.png";